<script setup lang="ts">
  import { ToastVariant } from '@tundr/theme';
  import { TUNDR_ICONS } from '@tundr/theme-assets/tundr-icons/tundr-icons-icons';
  import FontIcon from '../FontIcon/FontIcon.vue';
  import {
    disclaimerClass,
    disclaimerIconClass,
    disclaimerContentClass,
    disclaimerTitleClass,
    disclaimerFullWidthClass,
    disclaimerDescriptionClass,
    disclaimerVariants,
    disclaimerIconVariants,
  } from './Disclaimer.css';
  import { rowCenterClass } from '@tundr/theme';
  import { computed } from 'vue';

  export type DisclaimerProps = {
    id?: string;
    testId?: string;
    title?: string;
    description?: string;
    fullWidth?: boolean;
    variant?: ToastVariant;
  };

  const props = withDefaults(defineProps<DisclaimerProps>(), {
    variant: ToastVariant.INFO,
  });

  const disclaimerClasses = computed(() => [
    disclaimerClass,
    disclaimerVariants[props.variant],
    {
      [disclaimerFullWidthClass]: props.fullWidth,
    },
  ]);

  const disclaimerIconClasses = computed(() => [
    disclaimerIconClass,
    disclaimerIconVariants[props.variant],
  ]);

  const iconByVariant = computed(() => {
    const iconsMap = {
      [ToastVariant.ERROR]: TUNDR_ICONS.ERROR,
      [ToastVariant.WARNING]: TUNDR_ICONS.EXCLAMATION_TRIANGLE,
      [ToastVariant.SUCCESS]: TUNDR_ICONS.CHECK_CIRCLE,
      [ToastVariant.INFO]: TUNDR_ICONS.INFO,
    };
    return iconsMap[props.variant];
  });
</script>

<template>
  <div :class="disclaimerClasses">
    <div :class="disclaimerIconClasses">
      <FontIcon :icon-name="iconByVariant" />
    </div>
    <div :class="disclaimerContentClass">
      <div :class="disclaimerTitleClass">
        <slot name="title"> {{ title }} </slot>
      </div>
      <div :class="disclaimerDescriptionClass">
        <slot name="description"> {{ description }} </slot>
      </div>
    </div>
    <div v-if="$slots.actions" :class="rowCenterClass">
      <slot name="actions" />
    </div>
  </div>
</template>
